import React from 'react';
const spinner = () => (
    <div className="Loader">Loading...</div>
);

export default spinner;